module.exports = __webpack_public_path__ + "static/barcode-a6dc411f2fe4165cef3c1bae9111d04c.jpeg";